import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const MessageStreamPopoverContent = styled(Box)`
  display: flex;
  width: 100%;
`

export const MessageStreamWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 0 16px;
  width: 334px;
  position: relative;
`

export const MessageStreamTitleContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 2px 0;
  border-bottom: 1px solid ${colors.lightGrey};
  margin-bottom: 10px;
`

export const CloseButtonWrapper = styled(Box)`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 2px;
`
